// apps/web/src/components/landing-v2/proofs/NoStreakProof.tsx
/** Theme 01 / No-streak design — Free tier pull gauge + Cosmic upsell.
 *  Reference: handoff .mm-limit. */
export function NoStreakProof() {
  return (
    <div className="absolute inset-0 flex flex-col justify-end p-[18px]">
      {/* Pull gauge — top-anchored */}
      <div
        className="absolute left-[18px] right-[18px] top-[22px] flex items-center gap-3 rounded-xl border px-3.5 py-2.5 text-[12px] text-text-primary"
        style={{
          background: 'color-mix(in oklab, var(--color-gold-light-legacy) 6%, transparent)',
          borderColor: 'color-mix(in oklab, var(--color-gold-light-legacy) 22%, transparent)',
        }}
      >
        <div
          className="relative h-[26px] w-[26px] rounded-full"
          style={{
            background:
              'conic-gradient(var(--color-gold-light-legacy) 100%, var(--hairline) 0)',
          }}
        >
          <span
            className="absolute inset-[4px] flex items-center justify-center rounded-full text-[9px] font-medium text-gold-light-legacy"
            style={{ background: 'var(--color-cosmic-black)' }}
          >
            1/1
          </span>
        </div>
        <span className="leading-tight">
          🃏 <strong className="font-medium text-gold-light-legacy">1 of 1</strong>{' '}
          daily pull used
        </span>
      </div>

      {/* Cosmic upsell — bottom */}
      <div
        className="mt-auto flex items-center gap-2.5 rounded-lg border p-3"
        style={{
          background:
            'linear-gradient(135deg, color-mix(in oklab, var(--color-astral-violet) 18%, transparent), color-mix(in oklab, var(--color-astral-violet) 6%, transparent))',
          borderColor: 'color-mix(in oklab, var(--color-astral-violet) 28%, transparent)',
        }}
      >
        <span
          className="inline-flex h-7 w-7 items-center justify-center rounded-lg font-display text-astral-violet-light"
          style={{ background: 'color-mix(in oklab, var(--color-astral-violet) 25%, transparent)' }}
        >
          ✦
        </span>
        <div className="leading-tight">
          <div className="text-[10px] uppercase tracking-[0.18em] text-astral-violet-light">
            Cosmic
          </div>
          <div className="font-display italic text-text-primary" style={{ fontSize: '0.84rem' }}>
            Unlimited pulls →
          </div>
        </div>
      </div>
    </div>
  )
}
